import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {
  CreateManualModerationDto,
  CreatorModerationStatusEnum,
  ModerationFilterStatsDto,
} from '@/app/common/general-types/creators.dto';

export interface ModerationStatusDto {
  id?: string;
  createdDate?: string | Date;
  status: CreatorModerationStatusEnum;
  profilePic: boolean;
  firstName: boolean;
  lastName: boolean;
  connectedAccounts: number;
  avgViews: number;
  daysBetweenPosts: number;
  portfolioItems: number;
}

@Injectable({
  providedIn: 'root',
})
export class ModerateService {
  private http = inject(HttpClient);

  getModerateFilterCountsV2(): Observable<ModerationFilterStatsDto> {
    const moderate_filters_url = `${environment.shout_api.url}/creators/moderation-history/overall-stats/v2`;
    return this.http.get<ModerationFilterStatsDto>(moderate_filters_url, {
      headers: { 'Content-Type': 'application/json' },
    });
  }

  getModerateHistory(creatorId: string): Observable<ModerationStatusDto[]> {
    const url = `${environment.shout_api.url}/creators/moderation-history/creator/${encodeURIComponent(creatorId)}`;
    return this.http.get<ModerationStatusDto[]>(url, {
      headers: { 'Content-Type': 'application/json' },
    });
  }

  createManualModeration(newModeration: CreateManualModerationDto) {
    const create_manual_moderation_url = `${environment.shout_api.url}/creators/moderation-history/manual-moderation`;
    return this.http.post(create_manual_moderation_url, newModeration, {
      headers: { 'Content-Type': 'application/json' },
    });
  }
}
